// extracted by mini-css-extract-plugin
module.exports = {"atPaginationHeader":"AtPaginationHeader_atPaginationHeader__1HZ8I"};